module.exports = __webpack_public_path__ + "static/media/Teil_2_Backward.706359c8.ogv";


//////////////////
// WEBPACK FOOTER
// ./src/Teil_2_Backward.ogv
// module id = 120
// module chunks = 0